/** True when the learner API refused a premium lesson (HTTP 402). */
export function isPremiumRequiredError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const status = 'status' in error ? (error as { status: unknown }).status : undefined;
  return status === 402;
}

/**
 * Hide premium content from anyone who is not currently subscribed.
 * Fail closed: a catalog/detail flag or a 402 is enough. Do not wait for
 * `/v1/user` — that used to leak bundled pages (and spin on cloud 402s)
 * while Clerk or the user query was still loading.
 */
export function shouldHidePremiumContent(options: {
  flaggedPremium: boolean;
  paymentRequired: boolean;
  isSubscribed: boolean;
}): boolean {
  if (options.isSubscribed) return false;
  return options.paymentRequired || options.flaggedPremium;
}
